import { graphql, HttpResponse } from 'msw'
import {
  EnrollmentInvestmentExperienceCategory,
  EnrollmentInvestmentObjectiveCategory,
  type EnrollmentMultiInvestmentGoalsData,
  type EnrollmentMultiInvestmentGoalsSubmitOutput,
} from '../../../../models'

export const getEnrollmentMultiInvestmentGoalsDataMock: EnrollmentMultiInvestmentGoalsData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/investment-goals',
  enrollmentData: {
    progress: 0.5,
    investmentProfile: {
      experience: EnrollmentInvestmentExperienceCategory.VERY_LITTLE,
      objective: EnrollmentInvestmentObjectiveCategory.GENERATE_INCOME,
    },
  },
}

export const submitEnrollmentMultiInvestmentGoalsDataMock: EnrollmentMultiInvestmentGoalsSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/loading',
  enrollmentData: {
    progress: 0.5,
    investmentProfile: {
      experience: EnrollmentInvestmentExperienceCategory.VERY_LITTLE,
      objective: EnrollmentInvestmentObjectiveCategory.GENERATE_INCOME,
    },
  },
}

export const mockGetEnrollmentMultiInvestmentGoalsData = graphql.mutation(
  'getEnrollmentMultiInvestmentGoalsData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiInvestmentGoalsDataMock } })
  },
)

export const mockSubmitEnrollmentMultiInvestmentGoalsData = graphql.mutation(
  'submitEnrollmentMultiInvestmentGoalsData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiInvestmentGoalsDataMock } })
  },
)

export const mockEnrollmentMultiInvestmentGoals = [
  mockGetEnrollmentMultiInvestmentGoalsData,
  mockSubmitEnrollmentMultiInvestmentGoalsData,
]
